import React from "react";
import DoneIcon from "@mui/icons-material/Done";
const RadioButton = ({
  label,
  name,
  handleChange,
  radioType = "foo",
  setFormEmployee,
}) => {
  return (
    <div>
      <div class="options ">
        <label title="item1">
          <input
            type="radio"
            name={radioType}
            value="0"
            onChange={(value) => {
              let p = {
                name: `${name}`,
                value: value.target.checked,
              };
              {
                radioType == "foo"
                  ? handleChange(p)
                  : setFormEmployee({
                      name: label,
                      value: value.target.checked,
                    });
              }
            }}
          />

          <img
            style={{
              marginRight: 5,
            }}
          />
          <h6
            style={{
              margin: 0,
            }}
          >
            {label}
          </h6>
        </label>
      </div>
    </div>
  );
};

export default RadioButton;
